import { render, staticRenderFns } from "./tabTask.vue?vue&type=template&id=34ccc462&"
import script from "./tabTask.vue?vue&type=script&lang=ts&"
export * from "./tabTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports